import React from 'react';
import { LoaderStyles } from './Loader.styles';
const Loader = ({ inline = false, width = 10, size = 70, fillContainer = false, absolute = false, theme = 'black', }) => {
    return (React.createElement(LoaderStyles.Wrapper, { fillContainer: fillContainer, absolute: absolute },
        React.createElement(LoaderStyles.Loader, { inline: inline, width: width, size: size, theme: theme })));
};
export default Loader;
